import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../services/api"; // Import Axios instance
import "./Dashboard.css";

const Dashboard = () => {
  const [posts, setPosts] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [loadingPosts, setLoadingPosts] = useState(true);
  const [loadingBlogs, setLoadingBlogs] = useState(true);

  // Fetch posts from API
  const fetchPosts = async () => {
    try {
      const response = await api.get("/posts"); // Use Axios instance
      setPosts(response.data.posts);
    } catch (error) {
      console.error("Error fetching posts:", error);
    } finally {
      setLoadingPosts(false);
    }
  };

  // Fetch blogs from API
  const fetchBlogs = async () => {
    try {
      const response = await api.get("/blogs"); // Use Axios instance
      setBlogs(response.data.blogs);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    } finally {
      setLoadingBlogs(false);
    }
  };

  // Fetch data on component mount
  useEffect(() => {
    fetchPosts();
    fetchBlogs();
  }, []);

  return (
    <div className="dashboard">
      <div className="dashboard-overlayer">
        <div className="container">
          <div className="dashboard-header">
            <h1>Dashboard</h1>
          </div>

          <div className="dashboard-content">
            <h2>Manage Content</h2>

            <div className="actions">
              <Link to="/add-post" className="dashboard-link">
                Add New Post
              </Link>
              <Link to="/add-blog" className="dashboard-link">
                Add New Blog
              </Link>
            </div>

            <h3>Posts</h3>
            {loadingPosts ? (
              <p>Loading posts...</p>
            ) : (
              <div className="table-container">
                <table className="content-table">
                  <thead>
                    <tr>
                      <th>Media</th>
                      <th>Caption</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {posts?.map((post) => (
                      <tr key={post._id}>
                        <td>
                          <img
                            src={post.url}
                            alt="Media"
                            className="post-media"
                          />
                        </td>
                        <td>{post.caption}</td>
                        <td>{new Date(post.createdAt).toLocaleString()}</td>
                        <td>
                          <Link
                            to={`/edit-post/${post._id}`}
                            className="action-button"
                          >
                            Edit
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}

            <h3>Blogs</h3>
            {loadingBlogs ? (
              <p>Loading blogs...</p>
            ) : (
              <div className="table-container">
                <table className="content-table ">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Created At</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {blogs?.map((blog) => (
                      <tr key={blog._id}>
                        <td>{blog.title}</td>
                        <td>{new Date(blog.createdAt).toLocaleString()}</td>
                        <td>
                          <Link
                            to={`/edit-blog/${blog._id}`}
                            className="action-button"
                          >
                            Edit
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
